import React, {useEffect} from "react";
import {useDispatch} from "react-redux";
import {RouterProvider} from "react-router-dom";
import routingConstants from "./routingConstands";
import * as authorizationActions from "./store/actions/authorization.actions";
import {Actions} from "./store/actions/authorization.actions";
import FirebaseUsage from "./firebase/firebase.usage";
import {COLLECTIONS} from "./firebase/constants";
import {UserDocModel} from "./models/responses/user.model";
import LoaderPage from "./pages/LoaderPage/LoaderPage";
import AuthorizationThunk from "./store/thunk/authorization.thunk";
import {admins} from "./utils/admins";
import {useTypedSelector} from "./store/selectors/selectors.utils";
import firebaseConfig from "./config/firebase.config";
import {MemberOrganizationEnum} from "./models/member-organization.enum";
import SidebarExampleSidebar from "./pages/ProjectPage/components/UserSideBar/UserSideBar";
import FirebaseTeamFunctions from "./firebase/firebase-functions/team-service";


const AppRouting = () => {
  const dispatch = useDispatch();
  const checkedAuth = useTypedSelector(
    (state) => state.authorization.checkedAuth
  );
  const currentUser = useTypedSelector((state) => state.authorization.user);
  const sideBarOpen = useTypedSelector((state) => state.authorization.userSidebarOpen);
  const userNotificationsOpen = useTypedSelector((state) => state.authorization.userNotificationsOpen);
  const [sidebarScope, setSidebarScope] = React.useState("sidebar");

  useEffect(() => {
    if (sideBarOpen) {
      setSidebarScope("sidebar");
    } else if (userNotificationsOpen) {
      setSidebarScope("notifications");
    }
  }, [sideBarOpen, userNotificationsOpen]);

  const colorPalette = [
    '#e879f9', '#c084fc', '#f472b6', '#38bdf8', '#2dd4bf', '#f87171', '#fb923c', '#a3e635',
  ]

  useEffect(() => {
    if (checkedAuth && currentUser) {
      FirebaseUsage
        .getToken()
        .then(async (refreshedToken) => {
          try {
            await FirebaseUsage.updateDoc(COLLECTIONS.USERS, currentUser?.userId || "", {
                settings: {
                  ...currentUser.settings,
                  token: refreshedToken,
                },
              });
          } catch (e) {
            console.log("Error: Retrieve refreshedToken: ", e);
          }
        });
    }
  }, [checkedAuth, currentUser]);

  useEffect(() => {
    FirebaseUsage.auth().onAuthStateChanged(async (user) => {
      if (user && user.email && (!currentUser || user.email !== currentUser.userEmail)) {
        const accessToken = await user.getIdToken();
        const displayName = user.displayName;
        // const photoURL = user.photoURL;
        // let hasUser = false;
        // let userData: UserDocModel | any;
        // try {
        //   await FirebaseUsage.getQuery(COLLECTIONS.USERS, ["userEmail", "==", user.email]).
        //   then((snapshot) => {
        //       if (snapshot.docs.length) {
        //         // hasUser = true;
        //         userData = snapshot.docs[0] ? snapshot.docs[0].data() as UserDocModel : {userId: null, settings: {notifications: {}},};
        //       }
        //     }) } catch (e) {
        //   userData = {userId: user.uid, settings: {notifications: {}},};
        // }

        const userDataQuery = await FirebaseUsage.getQuery(COLLECTIONS.USERS, ["userEmail", "==", user.email]).
        then((snapshot) => snapshot.docs.map((doc) => doc.data() as UserDocModel));

        let userData: UserDocModel | any;

        if (userDataQuery.length) {
          userData = userDataQuery[0];
        }

        if (userData && !userData.userId) {
          userData.userId = user.uid;
        } else if (!userData) {
          userData = {userId: user.uid, settings: {notifications: {}},};
        }

        if (!userData.userColour) {
            userData.userColour = colorPalette[Math.floor(Math.random() * colorPalette.length)];
        }

        const newIsAdmin = user.email ? admins.includes(user.email) : false;
        let firebaseToken: any = null;
        try {
          if (!("Notification" in window)) {
            alert("This browser does not support desktop notification");
          } else if (Notification.permission === "granted") {
            firebaseToken = await FirebaseUsage.getTokenFromMessaging({
              vapidKey: firebaseConfig.vapidKey,
            });
          } else if (Notification.permission === "default") {
            Notification.requestPermission().then(() => {
              if (Notification.permission === "granted") {
                FirebaseUsage.getTokenFromMessaging({
                    vapidKey: firebaseConfig.vapidKey,
                  })
                  .then((currentToken) => {
                    if (currentToken) {
                      firebaseToken = currentToken;
                    }
                  });
              }
            });
          } else {
            alert("Notfications is not enabled please enable it ");
            firebaseToken = await FirebaseUsage.getTokenFromMessaging({
              vapidKey: firebaseConfig.vapidKey,
            });
          }
        } catch (error) {
          console.log("error", error);
        }

        if (!userData.lastLogin) {
          FirebaseTeamFunctions.addNewMember({
            userEmail: user.email,
            projectId: null,
            grade: MemberOrganizationEnum.ACTOR,
            clientId: null,
            userId: user.uid,
          }).then(() => {
            // TODO: Add loader for pending user memberships
          })
        }

        const userObj: UserDocModel = {
          userEmail: user.email || "",
          authenticated: true,
          isAdmin: newIsAdmin,
          // enableSA: userData.enableSA || false,
          trial: false,
          isDeleteProjects:false,
          asMember: {},
          ...userData,
          lastLogin: FirebaseUsage.timestamp(),
          displayName: displayName,
          totalVisits: userData.totalVisits ? userData.totalVisits += 1 : 1,
          settings: {
            token: null,
            firebaseToken: firebaseToken,
            notifications: {
              preferences: false,
              waitingToStart: false,
              started: false,
              resumed: false,
              reforecasted: false,
              suspended: false,
              declaredComplete: false,
              evaluatedComplete: false,
              addedByOthers: false,
              ...(userData.settings ? userData.settings.notifications : {}),
            },
          },
        };

        try {
          userObj.settings.token =
            await FirebaseUsage.getToken();
        } catch (error) {
          console.error(error);
        }
        await FirebaseUsage.setDocument(COLLECTIONS.USERS, userObj.userId, userObj)
        dispatch(authorizationActions.Actions.auth(userObj));
      } else {
        if (!currentUser) {
          // @ts-ignore
          dispatch(AuthorizationThunk.signInWithEmailLink());
        }
      }
    });
  }, [checkedAuth]);

  return checkedAuth ? (
      <div style={{minWidth: "100vw"}}>
        <SidebarExampleSidebar
            visible={(sideBarOpen && sidebarScope === 'sidebar')|| (userNotificationsOpen && sidebarScope === 'notifications')}
            scope={sidebarScope}
            setVisible={(bool: boolean) => userNotificationsOpen ?
                dispatch(Actions.setUserNotificationsOpen(bool)) :
                dispatch(Actions.setUserSidebarOpen(bool))}
            children={<RouterProvider router={routingConstants}/>}/>
      </div>
  ) : (
    <LoaderPage />
  );
};

export default AppRouting;
